module.exports = __webpack_public_path__ + "bin/67285f474e66ce174330d48904d70d2e.jpg";